<script lang="ts">
  import clsx from "clsx";
  import { onMount } from "svelte";
  import { fly } from "svelte/transition";
  import clickOutside from "../actions/clickOutside";
  import cart, {
    isCartActive,
    isCartLoading,
    toggleCart,
    cartItemCount,
  } from "../stores/cart";
  import { settings } from "../stores/settings";
  import CartItem from "./CartItem.svelte";
  import Currency from "./Currency.svelte";
  import Loader from "./Loader.svelte";

  const { shopUrl, cartUrl } = $settings;

  onMount(() => {
    cart.fetch();
  });
</script>

{#if $isCartActive}
  <div
    transition:fly={{ x: 400, duration: 500 }}
    use:clickOutside
    on:clickoutside={() => {
      toggleCart(false);
    }}
    class={clsx(
      "fixed top-0 right-0 w-screen h-screen max-w-md z-50 bg-white shadow-lg",
      $isCartActive ? "shadow-lg" : "translate-x-full"
    )}
  >
    <Loader isActive={$isCartLoading} />

    <button
      class="absolute top-7 right-6 z-10 text-gray-400 hover:text-gray-600"
      on:click={() => toggleCart(false)}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fill-rule="evenodd"
          d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
          clip-rule="evenodd"
        />
      </svg>
    </button>

    <div class="h-full flex flex-col justify-between">
      <div class="px-8 pt-6">
        <h2 class="mb-8">Ostoskori</h2>
      </div>

      <div class="flex-1 min-h-0 overflow-y-auto pb-4">
        {#if $cartItemCount > 0}
          <div class="px-8 space-y-6">
            {#each $cart.items as item}
              <CartItem {item} />
            {/each}
          </div>
        {:else if !$isCartLoading}
          <div class="h-full flex flex-col items-center justify-center">
            <p class="text-lg">Ostoskorisi on tyhjä</p>
            <div>
              <a href={shopUrl} class="button">Selaa tuotteita</a>
            </div>
          </div>
        {/if}
      </div>

      {#if $cartItemCount > 0}
        <div class="px-8 pt-4 pb-6 border-t-[1px] border-gray-300">
          <div class="flex justify-between">
            <div>
              <span class="text-lg">Yhteensä</span>
              <span class="text-sm text-gray-500">(alv 0 %)</span>
            </div>
            <span class="text-lg font-bold"
              ><Currency amount={$cart.subtotal} /></span
            >
          </div>

          <div class="mt-4 button-group is-equal-width">
            {#if cartUrl}
              <a href={cartUrl} class="button">Kassalle</a>
            {/if}
            <button class="button is-hollow" on:click={() => toggleCart(false)}
              >Jatka ostoksia</button
            >
          </div>
        </div>
      {/if}
    </div>
  </div>
{/if}
